import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  RUNUP_SEARCH_REQUEST,
  RUNUP_SEARCH_SUCCESS,
  RUNUP_SEARCH_FAILURE,
  RUNUP_SEARCH_AREA_FAILURE,
  RUNUP_SEARCH_AREA_REQUEST,
  RUNUP_SEARCH_AREA_SUCCESS,
  RUNUP_SEARCH_COUNTRY_FAILURE,
  RUNUP_SEARCH_COUNTRY_REQUEST,
  RUNUP_SEARCH_COUNTRY_SUCCESS,
  RUNUP_SEARCH_REGION_FAILURE,
  RUNUP_SEARCH_REGION_REQUEST,
  RUNUP_SEARCH_REGION_SUCCESS,
  RUNUP_SEARCH_RUNUP_AREA_FAILURE,
  RUNUP_SEARCH_RUNUP_AREA_REQUEST,
  RUNUP_SEARCH_RUNUP_AREA_SUCCESS,
  RUNUP_SEARCH_RUNUP_REGION_REQUEST,
  RUNUP_SEARCH_RUNUP_REGION_SUCCESS,
  RUNUP_SEARCH_RUNUP_REGION_FAILURE,
  RUNUP_SEARCH_RUNUP_COUNTRY_FAILURE,
  RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST,
  RUNUP_SEARCH_RUNUP_COUNTRY_SUCCESS,
  RUNUP_SEARCH_RUNUP_MEASURE_TYPE_FAILURE,
  RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST,
  RUNUP_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS,
  RUNUP_SEARCH_CAUSE_REQUEST,
  RUNUP_SEARCH_CAUSE_SUCCESS,
  RUNUP_SEARCH_CAUSE_FAILURE,
  RUNUP_SEARCH_VALIDITY_REQUEST,
  RUNUP_SEARCH_VALIDITY_SUCCESS,
  RUNUP_SEARCH_VALIDITY_FAILURE,
} from './runupSearchReducer';

const searchRunupsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/tsunamis/runups', ...action }),
  requestType: RUNUP_SEARCH_REQUEST,
  successType: RUNUP_SEARCH_SUCCESS,
  failureType: RUNUP_SEARCH_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/regions', ...action }),
  requestType: RUNUP_SEARCH_REGION_REQUEST,
  successType: RUNUP_SEARCH_REGION_SUCCESS,
  failureType: RUNUP_SEARCH_REGION_FAILURE,
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/countries', ...action }),
  requestType: RUNUP_SEARCH_COUNTRY_REQUEST,
  successType: RUNUP_SEARCH_COUNTRY_SUCCESS,
  failureType: RUNUP_SEARCH_COUNTRY_FAILURE,
});

const getAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/areas/${action.country}`, ...action }),
  requestType: RUNUP_SEARCH_AREA_REQUEST,
  successType: RUNUP_SEARCH_AREA_SUCCESS,
  failureType: RUNUP_SEARCH_AREA_FAILURE,
});

const getRunupRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/regions', ...action }),
  requestType: RUNUP_SEARCH_RUNUP_REGION_REQUEST,
  successType: RUNUP_SEARCH_RUNUP_REGION_SUCCESS,
  failureType: RUNUP_SEARCH_RUNUP_REGION_FAILURE,
});

const getRunupCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/countries', ...action }),
  requestType: RUNUP_SEARCH_RUNUP_COUNTRY_REQUEST,
  successType: RUNUP_SEARCH_RUNUP_COUNTRY_SUCCESS,
  failureType: RUNUP_SEARCH_RUNUP_COUNTRY_FAILURE,
});

const getRunupAreasSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/descriptors/tsunami/runup/areas/${action.country}`, ...action }),
  requestType: RUNUP_SEARCH_RUNUP_AREA_REQUEST,
  successType: RUNUP_SEARCH_RUNUP_AREA_SUCCESS,
  failureType: RUNUP_SEARCH_RUNUP_AREA_FAILURE,
});

const getRunupMeasureTypesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/runup/measurement-types', ...action }),
  requestType: RUNUP_SEARCH_RUNUP_MEASURE_TYPE_REQUEST,
  successType: RUNUP_SEARCH_RUNUP_MEASURE_TYPE_SUCCESS,
  failureType: RUNUP_SEARCH_RUNUP_MEASURE_TYPE_FAILURE,
});

const getValiditySaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/validity', ...action }),
  requestType: RUNUP_SEARCH_VALIDITY_REQUEST,
  successType: RUNUP_SEARCH_VALIDITY_SUCCESS,
  failureType: RUNUP_SEARCH_VALIDITY_FAILURE,
});

const getCauseSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/causes', ...action }),
  requestType: RUNUP_SEARCH_CAUSE_REQUEST,
  successType: RUNUP_SEARCH_CAUSE_SUCCESS,
  failureType: RUNUP_SEARCH_CAUSE_FAILURE,
});

export const searchRunupsSagas = [
  searchRunupsSaga,
  getRegionsSaga,
  getCountriesSaga,
  getAreasSaga,
  getRunupRegionsSaga,
  getRunupCountriesSaga,
  getRunupAreasSaga,
  getRunupMeasureTypesSaga,
  getValiditySaga,
  getCauseSaga,
];
